/**
 * Cart drawer upsell offers (v2).
 *
 * Loaded once per full page load (see snippets/cart-drawer.liquid) and uses
 * a single delegated click listener on `document`, so it keeps working after
 * the cart drawer's inner markup is swapped out by the theme's normal AJAX
 * cart refresh — no re-initialization logic needed, no duplicate listeners.
 *
 * Reuses the theme's own cart-update pipeline (assets/cart.js, assets/pubsub.js):
 * after a successful add we simply publish PUB_SUB_EVENTS.cartUpdate, which the
 * theme's existing <cart-drawer-items> component already listens for and reacts
 * to by re-fetching and re-rendering the cart drawer section — this is what
 * refreshes item count, subtotal, discounts AND re-evaluates which upsell
 * offers are still eligible (that logic lives in the Liquid snippet and simply
 * re-runs on every re-render).
 */
(function () {
  function fetchConfigJson() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    };
  }

  function strings() {
    return (
      window.cartUpsellOffersStrings || {
        error: "Couldn't add this item. Please try again.",
        soldOut: 'Sorry, this item just sold out.',
      }
    );
  }

  function setLoading(card, isLoading) {
    var btn = card.querySelector('[data-cuo-add]');
    var spinner = card.querySelector('.cuo-btn-spinner');
    var label = card.querySelector('.cuo-btn-label');
    var check = card.querySelector('.cuo-btn-check');
    if (!btn) return;
    btn.disabled = isLoading;
    if (spinner) spinner.hidden = !isLoading;
    if (label) label.hidden = isLoading;
    if (isLoading && check) check.hidden = true;
  }

  function showSuccess(card) {
    var check = card.querySelector('.cuo-btn-check');
    var label = card.querySelector('.cuo-btn-label');
    var spinner = card.querySelector('.cuo-btn-spinner');
    if (spinner) spinner.hidden = true;
    if (check) check.hidden = false;
    if (label) label.hidden = true;
  }

  function showError(card, message) {
    var err = card.querySelector('[data-cuo-error]');
    if (!err) return;
    err.textContent = message;
    err.hidden = false;
    window.clearTimeout(err._cuoTimeout);
    err._cuoTimeout = window.setTimeout(function () {
      err.hidden = true;
    }, 5000);
  }

  function getVariantId(card) {
    var select = card.querySelector('[data-cuo-variant-select]');
    if (select) return select.value;
    var hidden = card.querySelector('[data-cuo-variant-id]');
    return hidden ? hidden.value : null;
  }

  function notifyCartUpdated(variantId) {
    if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-upsell-offers',
        variantId: variantId,
      });
      return;
    }
    // Fallback, only used if pubsub.js hasn't loaded for some reason.
    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
      cartDrawerItems.onCartUpdate();
    }
  }

  var pendingCards = new WeakSet();

  function handleAdd(button) {
    var card = button.closest('[data-cuo-card]');
    if (!card || pendingCards.has(card)) return;

    var variantId = getVariantId(card);
    if (!variantId) {
      showError(card, strings().error);
      return;
    }

    var quantity = parseInt(button.getAttribute('data-cuo-quantity'), 10) || 1;

    pendingCards.add(card);
    setLoading(card, true);

    fetch(window.routes.cart_add_url,
      Object.assign({}, fetchConfigJson(), {
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
      })
    )
      .then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return { ok: response.ok, status: response.status, data: data };
          });
      })
      .then(function (result) {
        pendingCards.delete(card);

        if (!result.ok || result.data.status) {
          var message =
            result.status === 422
              ? strings().soldOut
              : (result.data && result.data.description) || strings().error;
          showError(card, message);
          setLoading(card, false);
          return;
        }

        showSuccess(card);
        notifyCartUpdated(variantId);
      })
      .catch(function (error) {
        pendingCards.delete(card);
        console.error('Cart upsell offers: failed to add item', error);
        showError(card, strings().error);
        setLoading(card, false);
      });
  }

  function scrollList(list, direction) {
    var card = list.querySelector('.cuo-card');
    var amount = card ? card.getBoundingClientRect().width + 16 : list.clientWidth;
    list.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  document.addEventListener('click', function (event) {
    var addBtn = event.target.closest('[data-cuo-add]');
    if (addBtn) {
      event.preventDefault();
      handleAdd(addBtn);
      return;
    }

    var navBtn = event.target.closest('.cuo-nav-btn');
    if (navBtn) {
      event.preventDefault();
      var wrap = navBtn.closest('.cuo-wrap');
      var list = wrap && wrap.querySelector('[data-cuo-list]');
      if (!list) return;
      scrollList(list, navBtn.classList.contains('cuo-next') ? 1 : -1);
    }
  });
})();
